<template>
  <el-container>
    <el-main v-if="customer">
      <el-row type="flex" justify="space-start" :gutter="30">
        <el-col :span="12">
          <el-card>
            <div class="card-header">
              <h4 class="title">Add a new customer</h4>
              <p class="category">Enter new customer details below:</p>
              <br>
            </div>
            <div class="card-content">
              <el-form :model="customer" :rules="rules" ref="customer" label-width="120px" class>
                <el-form-item label="Title" prop="title">
                  <el-select
                    size="large"
                    class="form-group border-input"
                    placeholder="Select Title"
                    v-model="customer.title"
                  >
                    <el-option
                      v-for="option in titles"
                      class="select-danger"
                      :value="option"
                      :label="option"
                      :key="option"
                    ></el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="Email" prop="email">
                  <el-input placeholder="Email" v-model="customer.email"></el-input>
                </el-form-item>

                <el-form-item label="Firstname" prop="firstname">
                  <el-input placeholder="Firstname" v-model="customer.firstname"></el-input>
                </el-form-item>

                <el-form-item label="Lastname" prop="lastname">
                  <el-input placeholder="Lastname" v-model="customer.lastname"></el-input>
                </el-form-item>
                <el-form-item label="Phone" prop="phone">
                  <el-input placeholder="Home phone number" v-model="customer.shippingAddress.data.phone"></el-input>
                </el-form-item>

                

                <el-form-item label="Address" prop="shippingAddress.data.line1">
                  <el-input placeholder="Address" v-model="customer.shippingAddress.data.line1"></el-input>
                </el-form-item>
                <el-form-item label prop="shippingAddress.data.line2">
                  <el-input type="text" placeholder="Address " v-model="customer.shippingAddress.data.line2"></el-input>
                </el-form-item>
                <el-form-item label="City/Town" prop="city">
                  <el-input type="text" placeholder="City" v-model="customer.shippingAddress.data.town"></el-input>
                </el-form-item>
                <el-form-item label="Postcode" prop="postalCode">
                  <el-input type="text" placeholder="Postcode" v-model="customer.shippingAddress.data.postcode"></el-input>
                </el-form-item>
                <el-form-item label="Region" prop="region">
                  <el-input type="text" placeholder="Region" v-model="customer.shippingAddress.data.region"></el-input>
                </el-form-item>
                <el-form-item label="Country" prop="shippingAddress.data.country">
                  <el-select
                    value-key="id"
                    class
                    size="small"
                    ref="selectedCountry"
                    style="width:100%"
                    v-model="customer.shippingAddress.data.country"
                    placeholder="Select a country"
                  >
                    <el-option
                    v-for="(country,index) in countries"
                      :value="index"
                      :label="country"
                      :key="index"
                    ></el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="Date of Birth" prop="dob">
                  <el-date-picker
                    v-model="customer.dateOfBirth"
                    type="date"
                    placeholder="Pick a day">
                  </el-date-picker>
                </el-form-item>

                <!--<el-form-item label="Gender" prop="gender">
                  <el-switch v-model="customer.gender" active-text="Male" inactive-text="Female"></el-switch>
                </el-form-item>
                <el-form-item label="Marketing" props="acceptsMarketing">
                  <el-switch
                    v-model="customer.acceptsMarketing"
                    active-text="Yes"
                    inactive-text="No"
                  ></el-switch>
                </el-form-item>-->

                <div class="clearfix"></div>
                <div class="card-footer text-right">
                  <el-button
                    type="primary"
                    v-on:click.prevent="saveCustomer('customer')"
                  
                  >Save Customer</el-button>
                   <el-button @click="resetForm('venue')">Reset</el-button>
                </div>
              </el-form>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </el-main>
  </el-container>
</template>
    <script>
import api from "./api";
import _ from "lodash";
import gql from 'graphql-tag'
import moment from "moment";
import json from "../../data/allCountries.json";
const CREATE_CUSTOMER=gql`
mutation createCustomer($customer: [Customer_insert_input!]!){
  insert_Customer(objects:$customer){
    returning{
      id

    }
    affected_rows
  }
}
`;
export default {
  data() {
    return {
      titles: ["Mr", "Mrs", "Miss", "Ms", "Dr", "Prof", "Rev"],
      customer: {shippingAddress:{data:{line1:'',line2:'',phone:'',region:'',postcode:'',country:''}}},
    
        countries:  json,
      // form validation
      rules: {
     
        firstname: [
          {
            required: true,
          
            message: "Please input name",
            trigger: "blur"
          }
        ],
        lastname: [
          {
            required: true,
        
            message: "Please input name",
            trigger: "blur"
          }
        ],
        line1: [
          { required: true, message: "Please add address", trigger: "change" }
        ],
        town: [
          { required: true, message: "Please add town", trigger: "change" }
        ],
        country: [
          { required: true, message: "Please add country", trigger: "blur" }
        ],
        email: [
          {
            type: "email",
            required: true,
            message: "Please input correct email address",
            trigger: "change"
          }
        ]
      }
    };
  },
  methods: {
    saveCustomer(formName) {
      this.customer.username=this.customer.email;
      this.customer.dateCreated=moment().format()
      const customer =this.customer && this.customer
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.$apollo.mutate({
            mutation:CREATE_CUSTOMER,
            variables:{
              customer:customer
            }
          }).then(result => {
            this.$notify({
                title: "Success",
                message: "Customer Created",
                type: "success"
            });
            this.$router.push({ path: "/customer/edit/" + result.data.insert_Customer.returning[0].id });
          }).catch(error => {
            this.$notify({
              title: "Error",
              message: error.message,
              type: "error"
            });
          });
        }
      });
    }
  },
  mounted() {
    //this.getCountries();
  }
};
</script>



// WEBPACK FOOTER //
// src/components/Customers/Create.vue